"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.interruptibleSleep = exports.sleep = void 0;
/**
 * Resolve promise after `ms` milliseconds
 */
const sleep = (ms) => new Promise((pass) => setTimeout(pass, ms));
exports.sleep = sleep;
/**
 * Resolve promise after `ms` milliseconds or when the provided Interrupt next fires,
 *  whichever occurs first.
 */
const interruptibleSleep = (interrupt, ms) => {
    return new Promise((pass) => {
        let timeout;
        let resolved = false;
        const resolve = () => {
            if (!resolved) {
                resolved = true;
                pass();
            }
            clearTimeout(timeout);
        };
        timeout = setTimeout(resolve, ms);
        interrupt.promise.then(resolve);
    });
};
exports.interruptibleSleep = interruptibleSleep;
//# sourceMappingURL=sleep.js.map